export class VisualizatorParser {
  constructor() {}

  parseSettings(/*settings*/) {
    return undefined;
  }

  createSaveableSettings() {
    return undefined;
  }

  applySaveableSettings(/*settings, saveableSettings*/) {}

  makeWebglConverters() {}

  createWebglSettings() {
    return undefined;
  }

  makeObjectCreators() {}

  createObjects() {
    return undefined;
  }
}
